// @givmo/fundraisers-module — the appeal's Social tab's words (EMC-WEB5; Email Campaign plan §1.1 step 7,
// walkthrough frames 39–40). Each account's state reads as Social ruled it for this tab (its SMM-BE22 coarse
// states and their lines, relayed 2026-11-03); "Needs attention" is Social's filter word, the tab's for a
// state this version doesn't know. The door and the not-offered card say who decides, after the user test
// (2026-11-03).

import type { SocialAccountState } from './campaign-social-decode';

/** "Instagram", "Instagram and LinkedIn", "Facebook, Instagram and LinkedIn". */
function joined(names: readonly string[]): string {
  if (names.length <= 1) return names[0] ?? '';
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}

export const CAMPAIGN_SOCIAL_COPY = {
  tab: 'Social',
  title: 'Posts',
  /** The small label over the posts with no time yet, grouped above the dated ones. */
  drafts: 'Drafts',
  editPost: 'Edit',
  loadFailed: 'We couldn’t load this campaign’s posts.',
  retry: 'Try again',
  empty: 'No posts about this campaign yet.',
  noTime: 'Not scheduled',
  noWords: 'A post with an image only',
  seeWhy: 'See why',
  /** Where a post may have gone out unconfirmed: look on the platform before trying again (Social's). */
  checkFirst: (platforms: readonly string[]): string =>
    `Check ${joined(platforms)} before trying again`,
  unavailableTitle: 'Social isn’t available',
  /** Social has no switch of the organization's own: Givmo turns it on. */
  unavailableBody: (org: string): string =>
    `Posting to social media isn’t on here. Ask Givmo to turn on Social for ${org}:`,
  /** D-EMC-10's door: the tab shows the posts to anyone with Fundraisers; writing one is Social's. */
  accessLine: (org: string): string =>
    `Posting to social media needs access to Social. Ask an admin at ${org} to give you access.`,
  requestAccess: 'Request access',
  requestAccessLabel: 'Request access to Social',
  /** The request reached Social's owners and the organization's Global Admins, who are notified. */
  accessRequested: (org: string): string => `Requested. ${org}’s admins have been told.`,
  state: {
    draft: 'Draft',
    scheduled: 'Scheduled',
    deferred: 'Held by the daily limit',
    posting: 'Posting',
    published: 'Published',
    unknown: 'Couldn’t confirm it posted',
    failed: 'Didn’t post',
    removed: 'Removed',
    attention: 'Needs attention',
  } satisfies Record<SocialAccountState, string>,
  /** The platforms by name, Social's words for its three accounts (`platformLabel`) and every other
   *  channel its timeline can serve (the Givmo feed's among them, seen on the served read). */
  platform: (platform: string): string =>
    ({
      facebook_pages: 'Facebook',
      instagram: 'Instagram',
      linkedin: 'LinkedIn',
      threads: 'Threads',
      bluesky: 'Bluesky',
      tiktok: 'TikTok',
      givmo: 'Givmo',
      company_announcement: 'Announcements',
      slack: 'Slack',
      teams: 'Microsoft Teams',
      test_social: 'Test platform',
    })[platform] ?? 'Social',
} as const;
